import { LOGIN } from '@/constants/routes';
import { destroyToken } from '@/services/jwt';
import { getToken } from '@/services/jwt';
import { createContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { User } from '../features/auth/types';
import { USER } from '@/api/queries';
import { restartGraphqlWsConnection } from '@/api/apollo';
import { useApolloClient, useQuery } from '@apollo/client';

export interface IAuthContext {
    user: User | null;
    refetchUser: () => Promise<any>;
    loadingUser: boolean;
    logout: () => Promise<void>;
} 

export const AuthContext = createContext<IAuthContext>({
    user: {}
} as IAuthContext);

export const useAuthContext = (): IAuthContext => {
    const navigate = useNavigate();
    const apolloClient = useApolloClient();
    const token = getToken();

    const { data, loading, refetch } = useQuery(USER, {
        fetchPolicy: 'network-only',
        skip: !token,
    });

    const logout = async () => {

        await apolloClient.clearStore();

        destroyToken();
        restartGraphqlWsConnection();

        navigate(LOGIN, { replace: true });
    }

    return {
        user: data?.me,
        refetchUser: refetch,
        loadingUser: loading,
        logout
    }
}